<h1 class="page-title">Misszionáriusanik</h1>

<h2>Mi a misszió?</h2>

<p>
  Jézus Krisztus, amikor tanítványai szemei láttára elkezdett emelkedni az ég felé, azt parancsolta tanítványainak, hogy
  menjenek, és hirdessék az evangéliumot a Föld végső határáig. Ennek célja nem a minél több tagot számlálás, hanem az
  emberek lelkeinek megmentése a haláltól. Ezt a missziót, vagyis küldetést vitték és viszik tovább a keresztények.
</p>

<p>
  Mind imával, mind anyagiakkal rendszeresen támogatunk missziókat, misszionáriusokat gyülekezetként is, de
  gyülekezetünkből többen egyénenként is. A teljesség igénye nélkül néhányan közülük:
</p>

<ul>
  <li>Mariann Józsi (Kína)</li>
  <li>Fadgyas András (Kína)</li>
  <li>Kerekes Lajos (Peru)</li>
  <li>Szabó József (Mezőberény)</li>
  <li>Julian Timofte</li>
  <li>Balázs Kornél</li>
</ul>

<p>
  Ha szeretnél támogatni te is missziókat, megteheted a gyülekezetben: találsz borítékot a persely mellett, és ha ráírsz
  egy nevet / missziót, akkor azt az adományt teljes egészében átadjuk az illetékes(ek)nek. Ha más módon szeretnéd ezt
  tenni, akkor további segítségért, információért keresd bátran Fodor Jánost (70/701-7834).
</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/missionaries/missionaries.component.html